// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type TableTreeMapQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
}>;

export type TableTreeMapQuery = {
  __typename?: "GraphqlQuery";
  getSchemaTables: Array<{
    __typename?: "SchemaTable";
    id: string;
    schemaName: string;
    tableName: string;
    lastStats?: {
      __typename?: "SchemaTableInlineStats";
      dataSizeBytes?: number | null;
    } | null;
  }>;
};

export const TableTreeMapDocument = gql`
  query TableTreeMap($databaseId: ID!) {
    getSchemaTables(databaseId: $databaseId) {
      id
      schemaName
      tableName
      lastStats {
        dataSizeBytes
      }
    }
  }
`;

/**
 * __useTableTreeMapQuery__
 *
 * To run a query within a React component, call `useTableTreeMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableTreeMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableTreeMapQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useTableTreeMapQuery(
  baseOptions: Apollo.QueryHookOptions<
    TableTreeMapQuery,
    TableTreeMapQueryVariables
  > &
    (
      | { variables: TableTreeMapQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TableTreeMapQuery, TableTreeMapQueryVariables>(
    TableTreeMapDocument,
    options,
  );
}
export function useTableTreeMapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TableTreeMapQuery,
    TableTreeMapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TableTreeMapQuery, TableTreeMapQueryVariables>(
    TableTreeMapDocument,
    options,
  );
}
// @ts-ignore
export function useTableTreeMapSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TableTreeMapQuery,
    TableTreeMapQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<TableTreeMapQuery, TableTreeMapQueryVariables>;
export function useTableTreeMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TableTreeMapQuery,
        TableTreeMapQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TableTreeMapQuery | undefined,
  TableTreeMapQueryVariables
>;
export function useTableTreeMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TableTreeMapQuery,
        TableTreeMapQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TableTreeMapQuery, TableTreeMapQueryVariables>(
    TableTreeMapDocument,
    options,
  );
}
export type TableTreeMapQueryHookResult = ReturnType<
  typeof useTableTreeMapQuery
>;
export type TableTreeMapLazyQueryHookResult = ReturnType<
  typeof useTableTreeMapLazyQuery
>;
export type TableTreeMapSuspenseQueryHookResult = ReturnType<
  typeof useTableTreeMapSuspenseQuery
>;
export type TableTreeMapQueryResult = Apollo.QueryResult<
  TableTreeMapQuery,
  TableTreeMapQueryVariables
>;
